export default __webpack_public_path__ + "static/media/5.9f3f7c0b.png";